import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "hideDigits",
})
export class PhoneHideDigitsPipe implements PipeTransform {
  transform(phone_number: string, visible_digits_count: number = 4): string {
    const total_digits = phone_number.length;
    const hidden_digits_count = total_digits - visible_digits_count;
    const hidden_digits = "*".repeat(hidden_digits_count);
    const visible_digits = phone_number.slice(-visible_digits_count);
    return `${hidden_digits}${visible_digits}`;
  }
}
